import { fetchToken } from "../../../common/FetchCookie";
import { BASE_URL, CORE, CORE_JOB_DEPARTMENTS } from "../../../common/URLs";

export const fetchJobDepartments = async () => {
  const url = `${BASE_URL}/${CORE}/${CORE_JOB_DEPARTMENTS}`; // Proxy path
  try {
    const token = await fetchToken();

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    //   console.log("response", response)
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
  }
};

export const addJobDepartment = async (newJobDepartment) => {
  const url = `${BASE_URL}/${CORE}/${CORE_JOB_DEPARTMENTS}`; // Proxy path
  try {
    const token = await fetchToken();

    const response = await fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(newJobDepartment),
    });
    const data = await response.json();
    console.log("API Data", data);
    return data;
  } catch (error) {
    console.log("error", error);
    throw error;
  }
};

export const deleteJobDepartment = async (uuid) => {
  try {
    const token = await fetchToken();

    const response = await fetch(
      `${BASE_URL}/${CORE}/${CORE_JOB_DEPARTMENTS}/${uuid}`,
      {
        method: "DELETE",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error("Error deleting job Department: " + response.statusText);
    }

    return await response.json();
  } catch (error) {
    throw new Error("Error deleting job Department: " + error.message);
  }
};

export const updateJobDepartment = async (uuid, jobDepartmentData) => {
  try {
    const token = await fetchToken();

    const response = await fetch(
      `${BASE_URL}/${CORE}/${CORE_JOB_DEPARTMENTS}/${uuid}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(jobDepartmentData),
      }
    );
    // console.log("Response: ", response)

    if (!response.ok) {
      throw new Error("Error updating job Department: " + response.statusText);
    }

    return await response.json();
  } catch (error) {
    throw new Error("Error updating job Department: " + error.message);
  }
};
